import HintText from '../HintText'
import styled from 'styled-components'

const ErrorText = styled(HintText)`
  color: ${({ theme }) => theme.colors.red4};
`

export default ErrorText
